export const BACKEND_URL: string = 'https://zeroadmin.synapto.ch/api';
